"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadcastBeaconError = void 0;
const __1 = require("..");
class BroadcastBeaconError extends __1.BeaconError {
    constructor() {
        super(__1.BeaconErrorType.BROADCAST_ERROR, 'The transaction could not be broadcast to the network. Please try again.');
        this.name = 'BroadcastBeaconError';
        this.title = 'Broadcast Error';
    }
}
exports.BroadcastBeaconError = BroadcastBeaconError;
//# sourceMappingURL=BroadcastBeaconError.js.map